/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_VInputs */



/**
* | output |
* | --- |
* | "V" |
*
* @param {Editor_Table_Column_VInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_v = /** @type {((inputs?: Editor_Table_Column_VInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_VInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("V")
	if (locale === "de") return /** @type {LocalizedString} */ ("V")
	if (locale === "it") return /** @type {LocalizedString} */ ("V")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В")
	if (locale === "es") return /** @type {LocalizedString} */ ("V")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("V")
	if (locale === "ja") return /** @type {LocalizedString} */ ("V")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("V")
	return /** @type {LocalizedString} */ ("V")
});